import React from 'react';

/** Mai più pagine bianche mute: qualsiasi crash del render mostra questo pannello. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Errore applicazione:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: 'sans-serif', textAlign: 'center' }}>
          <h2>⚠️ Qualcosa è andato storto</h2>
          <p style={{ color: '#666' }}>{String(this.state.error?.message || this.state.error)}</p>
          <button
            style={{ padding: '10px 24px', fontSize: 16, cursor: 'pointer', borderRadius: 8 }}
            onClick={() => window.location.reload()}
          >
            Ricarica l'app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
